export default function Contact() {
  return (
    <section id="hubungi" className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm font-semibold mb-4 sm:mb-6">
            <i className="ri-customer-service-2-line"></i>
            Hubungi Kami
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800 mb-4 sm:mb-6 px-4">
            📞 Hubungi Kami
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto px-4">
            Untuk sebarang pertanyaan atau maklumat lanjut mengenai kempen ini
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 sm:gap-12 items-center">
          {/* Contact Info */}
          <div className="space-y-4 sm:space-y-6">
            <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-3xl p-6 sm:p-8 border border-emerald-100">
              <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4 sm:mb-6">
                Persatuan Bekas Pasukan Keselamatan Negara Malaysia (PBPKNM)
              </h3>

              <div className="space-y-4 sm:space-y-5">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-emerald-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-lg sm:text-xl text-white"></i>
                  </div>
                  <div>
                    <div className="text-xs sm:text-sm text-gray-500 mb-1">Emel</div>
                    <div className="text-sm sm:text-base font-semibold text-gray-800 break-all">info@pbpknm.com</div>
                  </div>
                </div>

                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-whatsapp-line text-lg sm:text-xl text-white"></i>
                  </div>
                  <div>
                    <div className="text-xs sm:text-sm text-gray-500 mb-1">WhatsApp</div>
                    <div className="text-sm sm:text-base font-semibold text-gray-800">+60 10-2244 754</div>
                  </div>
                </div>

                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-global-line text-lg sm:text-xl text-white"></i>
                  </div>
                  <div>
                    <div className="text-xs sm:text-sm text-gray-500 mb-1">Laman Web</div>
                    <div className="text-sm sm:text-base font-semibold text-gray-800 break-all">www.pbpknm.com</div>
                  </div>
                </div>

                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-amber-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-lg sm:text-xl text-white"></i>
                  </div>
                  <div>
                    <div className="text-xs sm:text-sm text-gray-500 mb-1">Alamat</div>
                    <div className="text-sm sm:text-base font-semibold text-gray-800">
                      No 11-4, tingkat 4, Jln 11/48A, Sentul Raya Boulevard 51000, Kuala Lumpur, Malaysia
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Social Media */}
            <div className="bg-white rounded-2xl p-5 sm:p-6 shadow-lg border border-gray-100">
              <h4 className="text-base sm:text-lg font-bold text-gray-800 mb-3 sm:mb-4">Ikuti Kami</h4>
              <div className="flex gap-3">
                <a 
                  href="#"
                  className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-500 rounded-xl flex items-center justify-center hover:scale-110 transition-transform cursor-pointer"
                >
                  <i className="ri-facebook-fill text-lg sm:text-xl text-white"></i>
                </a>
                <a 
                  href="#"
                  className="w-10 h-10 sm:w-12 sm:h-12 bg-sky-500 rounded-xl flex items-center justify-center hover:scale-110 transition-transform cursor-pointer"
                >
                  <i className="ri-twitter-x-line text-lg sm:text-xl text-white"></i>
                </a>
                <a 
                  href="#"
                  className="w-10 h-10 sm:w-12 sm:h-12 bg-pink-500 rounded-xl flex items-center justify-center hover:scale-110 transition-transform cursor-pointer"
                >
                  <i className="ri-instagram-line text-lg sm:text-xl text-white"></i>
                </a>
                <a 
                  href="#"
                  className="w-10 h-10 sm:w-12 sm:h-12 bg-red-500 rounded-xl flex items-center justify-center hover:scale-110 transition-transform cursor-pointer"
                >
                  <i className="ri-youtube-fill text-lg sm:text-xl text-white"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-6 sm:p-8 shadow-xl border border-gray-100">
            <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4 sm:mb-6">Hantar Mesej</h3>
            
            <form className="space-y-4">
              <div>
                <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">Nama</label>
                <input 
                  type="text"
                  name="contact_name"
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-emerald-500 focus:outline-none text-sm sm:text-base"
                  placeholder="Nama anda"
                />
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">Emel</label>
                <input 
                  type="email"
                  name="contact_email"
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-emerald-500 focus:outline-none text-sm sm:text-base"
                  placeholder="emel@contoh.com"
                />
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">Telefon</label>
                <input 
                  type="tel"
                  name="contact_phone"
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-emerald-500 focus:outline-none text-sm sm:text-base"
                  placeholder="01X-XXX XXXX"
                />
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-semibold text-gray-700 mb-2">Mesej</label>
                <textarea 
                  name="contact_message"
                  rows={4}
                  maxLength={500}
                  required
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-emerald-500 focus:outline-none resize-none text-sm sm:text-base"
                  placeholder="Tulis mesej anda di sini..."
                ></textarea>
                <div className="text-xs text-gray-500 mt-1">Maksimum 500 aksara</div>
              </div>

              <button 
                type="submit"
                className="w-full px-6 py-3 sm:py-4 bg-gradient-to-r from-emerald-600 to-teal-600 text-white text-sm sm:text-base font-bold rounded-xl hover:shadow-lg hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <span className="flex items-center justify-center gap-2">
                  <i className="ri-send-plane-fill"></i>
                  Hantar Mesej
                </span>
              </button>
            </form>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-12 sm:mt-16 bg-gradient-to-r from-emerald-100 to-amber-100 rounded-3xl p-6 sm:p-8 text-center">
          <p className="text-sm sm:text-lg text-gray-700 leading-relaxed">
            <i className="ri-information-line text-emerald-600"></i> 
            <strong> Waktu Operasi:</strong> Isnin - Jumaat, 9:00 AM - 5:00 PM
          </p>
        </div>
      </div>
    </section>
  );
}
